import React from 'react'; 

import ReactDOM from 'react-dom/client'; 

import './index.css'; 

import "./components/AllCss.css" 

import App from './App'; 

import reportWebVitals from './reportWebVitals'; 

import "primeflex/primeflex.css";

import "primereact/resources/themes/lara-light-cyan/theme.css"; 

import { PrimeReactProvider } from "primereact/api"; 

const root = ReactDOM.createRoot(document.getElementById('root')); 

root.render( 

  <React.StrictMode> 

    <App /> 

  </React.StrictMode> 

); 

  

reportWebVitals(); 

 